module.exports = function () {
  window.$ = window.jQuery = require('jquery');
  require('./feedback.min.js');
  var FeedbackComponent = window.Feedback;
  return FeedbackComponent;
}();